import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Space } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

/**
 * هدر یکدست صفحات ماژول کار — گرادیانت ملایم سبز برند در حالت روشن
 */
const WorkPageHeader = ({
  title,
  subtitle,
  icon: Icon,
  actions,
  headerExtra,
  showBack = false,
  backPath,
  onBack,
  iconClassName = 'work-page-header-icon',
  iconColorClass = 'text-brand-primary',
}) => {
  const navigate = useNavigate();
  const extra = actions ?? headerExtra;

  return (
    <div className="work-page-header-gradient flex flex-wrap items-center justify-between gap-4 p-6 rounded-t-xl">
      <div className="flex items-center gap-3 min-w-0">
        {Icon ? (
          <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${iconClassName}`}>
            <Icon className={`text-xl ${iconColorClass}`} />
          </div>
        ) : null}
        <div className="min-w-0">
          <h1
            className="text-2xl font-bold text-gray-800 dark:text-white m-0 truncate work-page-header-title"
            style={{ fontFamily: 'CustomFont' }}
          >
            {title}
          </h1>
          {subtitle ? (
            <p
              className="text-gray-600 dark:text-white/65 text-sm m-0 mt-1 work-page-header-subtitle"
              style={{ fontFamily: 'CustomFont' }}
            >
              {subtitle}
            </p>
          ) : null}
        </div>
      </div>
      {(showBack || extra) ? (
        <Space wrap className="work-page-header-actions">
          {showBack && (backPath || onBack) ? (
            <Button
              icon={<ArrowRightOutlined />}
              onClick={() => (onBack ? onBack() : navigate(backPath))}
              className="work-page-header-back-btn"
              style={{ fontFamily: 'CustomFont' }}
            >
              بازگشت
            </Button>
          ) : null}
          {extra}
        </Space>
      ) : null}
    </div>
  );
};

export default WorkPageHeader;
